import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Globe } from "lucide-react";

const SettingsRoot: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="space-y-4">
      {/* Language Settings */}
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex items-center mb-4">
          <Globe className="w-5 h-5 text-[#264a3e] mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">
            {t('settings.languageSettings')}
          </h3>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t('settings.selectLanguage')}
            </label>
            <p className="text-sm text-gray-500 mb-4">
              {t('settings.languageDescription')}
            </p>
            <div className="px-4 py-3 border-2 rounded-lg border-[#264a3e] bg-[#264a3e] text-white">
              <div className="text-center">
                <div className="font-semibold">{t('common.english')}</div>
                <div className="text-xs mt-1">English (Default Language)</div>
              </div>
            </div>
            <p className="text-sm text-gray-500 mt-3">
              Greek Call Center uses English as the default interface language.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsRoot;
